(() => {
  if (window.__madeInWishlist) return;
  window.__madeInWishlist = true;
  const KEY = 'madein_wishlist_v3';
  const LEGACY_KEY = 'madein_wishlist_v2';
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || localStorage.getItem(LEGACY_KEY) || '[]');
      if (!Array.isArray(value)) return [];
      return value.map((item) => typeof item === 'string' ? { handle: item } : item).filter((item) => item?.handle);
    } catch (_) { return []; }
  };
  let items = read();
  const write = () => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); localStorage.removeItem(LEGACY_KEY); } catch (_) {}
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const createDrawer = () => {
    if (document.querySelector('[data-mi-wishlist-drawer]')) return;
    document.body.insertAdjacentHTML('beforeend', `<div class="mi-wishlist" data-mi-wishlist-drawer hidden><button class="mi-wishlist__backdrop" type="button" data-mi-wishlist-close aria-label="إغلاق المفضلة"></button><aside class="mi-wishlist__panel" role="dialog" aria-modal="true" aria-labelledby="mi-wishlist-title" dir="rtl"><header><div><small>اختياراتك المحفوظة</small><h2 id="mi-wishlist-title">المفضلة <span data-mi-wishlist-heading-count></span></h2></div><button type="button" class="mi-wishlist__close" data-mi-wishlist-close aria-label="إغلاق">×</button></header><div class="mi-wishlist__body" data-mi-wishlist-body></div><footer><a href="/collections/all">متابعة التسوق</a><button type="button" data-mi-wishlist-clear>مسح المفضلة</button></footer></aside></div>`);
  };
  const sync = () => {
    const handles = new Set(items.map((item) => item.handle));
    document.querySelectorAll('[data-made-wishlist]').forEach((button) => {
      const active = handles.has(button.dataset.madeWishlist);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? button.dataset.labelRemove : button.dataset.labelAdd);
    });
    document.querySelectorAll('.mi-header-wishlist-link').forEach((link) => {
      let badge = link.querySelector('.mi-wishlist-count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'mi-wishlist-count'; link.append(badge); }
      if (badge.textContent !== String(items.length)) badge.textContent = String(items.length);
      badge.hidden = items.length === 0;
      link.classList.toggle('has-items', items.length > 0);
      link.setAttribute('aria-label', `المفضلة، ${items.length} منتج`);
    });
  };
  const render = () => {
    createDrawer();
    const body = document.querySelector('[data-mi-wishlist-body]');
    const count = document.querySelector('[data-mi-wishlist-heading-count]');
    if (count) count.textContent = items.length ? `(${items.length})` : '';
    if (!body) return;
    if (!items.length) { body.innerHTML = '<div class="mi-wishlist__empty"><b>♡</b><strong>المفضلة فارغة</strong><p>اضغط على القلب بجوار أي منتج لحفظه هنا.</p><a href="/collections/all">استكشف المنتجات</a></div>'; return; }
    body.innerHTML = `<div class="mi-wishlist__grid">${items.map((item) => `<article data-wishlist-item="${escapeHtml(item.handle)}"><a href="${escapeHtml(item.url || `/products/${item.handle}`)}"><span>${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="180" height="225">` : ''}</span><strong>${escapeHtml(item.title || item.handle)}</strong>${item.price ? `<small>${escapeHtml(item.price)}</small>` : ''}</a><button type="button" data-mi-wishlist-remove="${escapeHtml(item.handle)}" aria-label="إزالة من المفضلة">إزالة</button></article>`).join('')}</div>`;
  };
  const open = () => {
    render(); const drawer = document.querySelector('[data-mi-wishlist-drawer]');
    drawer.hidden = false; requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.documentElement.classList.add('mi-wishlist-open'); drawer.querySelector('.mi-wishlist__close')?.focus();
  };
  const close = () => {
    const drawer = document.querySelector('[data-mi-wishlist-drawer]'); if (!drawer) return;
    drawer.classList.remove('is-open'); document.documentElement.classList.remove('mi-wishlist-open');
    setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 260);
  };
  document.addEventListener('click', (event) => {
    const heart = event.target.closest?.('[data-made-wishlist]');
    if (heart) {
      event.preventDefault(); event.stopImmediatePropagation();
      const handle = heart.dataset.madeWishlist; const index = items.findIndex((item) => item.handle === handle);
      if (index >= 0) items.splice(index, 1); else items.unshift({handle,title:heart.dataset.productTitle,url:heart.dataset.productUrl,image:heart.dataset.productImage,price:heart.dataset.productPrice});
      write(); sync(); render(); return;
    }
    if (event.target.closest?.('.mi-header-wishlist-link')) { event.preventDefault(); open(); return; }
    if (event.target.closest?.('[data-mi-wishlist-close]')) { close(); return; }
    const remove = event.target.closest?.('[data-mi-wishlist-remove]');
    if (remove) { items = items.filter((item) => item.handle !== remove.dataset.miWishlistRemove); write(); sync(); render(); return; }
    if (event.target.closest?.('[data-mi-wishlist-clear]')) { items = []; write(); sync(); render(); }
  }, true);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  window.addEventListener('storage', () => { items = read(); sync(); render(); });
  new MutationObserver(sync).observe(document.documentElement, {childList:true,subtree:true});
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', sync, {once:true}) : sync();
})();
